import { create } from 'zustand'
import { useFormSaveStore } from '../../utils'

export type MLPResult = {
    parking_results_uuid: string
    category: 'mlp' | 'confirmed_violator'
}
type MLPStore = {
    currentBatch: number
    changeCurrentBatch: (batch: number) => void
    changeCurrentActiveBatch: (batch: number) => void
    results: MLPResult[][]
    addResult: (result: MLPResult, indexInBatch: number) => string | void
    currentActiveBatch: number
    mlpFinished: boolean
    setMlpFinished: (finished: boolean) => void
}

export const useMLPStore = create<MLPStore>((set, get) => ({
    currentBatch: 0,
    currentActiveBatch: 0,
    results: [],
    mlpFinished: false,
    setMlpFinished: (finished: boolean) => set({ mlpFinished: finished }),
    changeCurrentActiveBatch: (batch: number) => set({ currentActiveBatch: batch }),
    changeCurrentBatch: (batch: number) => set({ currentBatch: batch }),

    addResult: (result: MLPResult, indexInBatch: number) => {
        const formChangeStore = useFormSaveStore.getState()

        if (get().currentBatch > get().currentActiveBatch) {
            return 'Batch is not yet active'
        }
        if (get().currentBatch < get().currentActiveBatch) {
            return 'Batch is already submitted'
        }
        if (get().mlpFinished) {
            return 'MLP is already finished'
        }
        formChangeStore.setFormChanges(true)
        const results = get().results
        let resultsAtBatch = results[get().currentBatch] //get results at current batch
        if (resultsAtBatch) {
            if (resultsAtBatch[indexInBatch]) {
                //edited past result
                resultsAtBatch[indexInBatch] = result //edited past result
            } else {
                //new result
                resultsAtBatch[indexInBatch] = result
            }
        } else {
            resultsAtBatch = []
            resultsAtBatch[indexInBatch] = result
        }
        results[get().currentBatch] = resultsAtBatch

        set({ results: [...results] })
    }
}))
